export default __webpack_public_path__ + "static/media/mid7.bd92f92b.jpg";